import { PDFDownloadLink } from '@react-pdf/renderer'
import { useQueryClient } from '@tanstack/react-query'
import ArticulosPDF from 'components/pdf/ArticulosPDF'
import Loader from 'components/Spinner/Loader'
import { CustomButton } from 'components/ui'
import { useVersionModel } from 'hooks/useVersionModel'
import { useGetAllArticulosByProject } from 'lib/react-query/queries'
import React from 'react'
import { useParams } from 'react-router-dom'
import { getCurrentDay } from 'utils/formatsDate'

const PdfArticulosButton = () => {
  const { idProject } = useParams()
  const queryClient = useQueryClient()
  const { currentVersion } = useVersionModel()

  // Se especifica la página (1) para que la query se ejecute con esa configuración
  const { data, isLoading } = useGetAllArticulosByProject(idProject, {
    limit: 100000,
    sort: 'articulo.code',
    version: currentVersion,
    page: 1,
  })

  const project = queryClient.getQueryData(['project', idProject])
  const fechaActual = getCurrentDay()
  const titlePdf = `${project?.data?.proyecto?.name}_${fechaActual}`

  if (isLoading)
    return (
      <CustomButton className="btn-center" disabled>
        <Loader size={14} color="white" />
      </CustomButton>
    )

  return (
    <CustomButton className="btn-center">
      <PDFDownloadLink
        document={
          <ArticulosPDF
            data={data.data.articulos} 
            today={fechaActual}
            titlePdf={project?.data?.proyecto?.name}
          />
        }
        fileName={`Articulos_${titlePdf}.pdf`}
        style={{ textDecoration: 'none', color: 'white' }}
      >
        {({ blob, url, loading, error }) =>
          loading ? <Loader size={14} color="white" /> : 'PDF'
        }
      </PDFDownloadLink>
    </CustomButton>
  )
}

export default PdfArticulosButton
